/* Yumeka - composants ajoutés (carrousel, jauges, cartes de lot).
   Même contrat que theme.js : tout fonctionne sans ce fichier, il ne fait
   qu'ajouter du confort par-dessus du HTML déjà utilisable. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Carrousel + jauges ---------------------------------------- */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (root) {
      var track  = $('[data-carousel-track]', root);
      var gauges = $$('[data-gauge]', root);
      if (!track || !gauges.length) return;

      var slides = $$('[data-carousel-slide]', track);
      var current = -1;

      function paint(index) {
        if (index === current) return;
        current = index;
        gauges.forEach(function (g, i) {
          var bar = $('.gauge__bar', g);
          // Une jauge déjà dépassée reste pleine : la progression se lit de
          // gauche à droite, comme une barre de lecture.
          if (bar) bar.style.strokeDashoffset = i <= index ? '0' : 'var(--c)';
          g.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function nearest() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, dist = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < dist) { dist = d; best = i; }
        });
        return best;
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { paint(nearest()); ticking = false; });
      }, { passive: true });

      gauges.forEach(function (g) {
        g.addEventListener('click', function () {
          var i = parseInt(g.getAttribute('data-index'), 10) || 0;
          var s = slides[i];
          if (!s) return;
          track.scrollTo({
            left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2,
            behavior: reduce ? 'auto' : 'smooth'
          });
        });
      });

      paint(0);
    });
  }

  /* ---------- Anneaux de statistiques ----------------------------------- */
  /* L'anneau et le chiffre sont peints par la même boucle, avec la même
     fonction d'assouplissement : ils ne peuvent donc pas se décaler en cours
     de course, ce qu'un pas linéaire produirait au milieu de l'animation.
     Le HTML servi porte déjà la valeur finale et l'anneau rempli ; le JS ne
     remet à zéro qu'au moment précis où il démarre l'animation. */
  function initRings() {
    var rings = $$('[data-ring]');
    if (!rings.length) return;

    var DUR = 1500;

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function parts(ring) {
      var full = parseFloat(window.getComputedStyle(ring).getPropertyValue('--c'));
      var bar  = $('.gauge__bar', ring);
      return {
        // Sans circonférence exploitable, on laisse l'anneau à son état CSS
        // de repos plutôt que de l'animer depuis une valeur fausse.
        bar:    full > 0 ? bar : null,
        full:   full > 0 ? full : 0,
        count:  $('[data-count]', ring),
        value:  parseFloat(ring.getAttribute('data-value')) || 0,
        offset: parseFloat(ring.getAttribute('data-offset')) || 0,
        suffix: ring.getAttribute('data-suffix') || ''
      };
    }

    function settle(p) {
      if (p.bar) p.bar.style.strokeDashoffset = p.offset;
      if (p.count) p.count.textContent = p.value + p.suffix;
    }

    function run(ring) {
      var p = parts(ring);
      if (!p.bar && !p.count) return;

      var start = null;
      function frame(now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / DUR, 1);
        var e = easeInOut(t);
        if (p.bar) p.bar.style.strokeDashoffset = p.full - (p.full - p.offset) * e;
        if (p.count) p.count.textContent = Math.round(p.value * e) + p.suffix;
        if (t < 1) window.requestAnimationFrame(frame);
        else settle(p);
      }

      if (p.bar) p.bar.style.strokeDashoffset = p.full;
      if (p.count) p.count.textContent = 0 + p.suffix;
      window.requestAnimationFrame(frame);
    }

    if (reduce || !('IntersectionObserver' in window) || !window.requestAnimationFrame) {
      rings.forEach(function (r) { settle(parts(r)); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        run(e.target);
      });
    }, { threshold: 0.4 });

    rings.forEach(function (r) { io.observe(r); });
  }

  /* ---------- Cartes de lot --------------------------------------------- */
  /* Le prix, la quantité envoyée au panier et la barre collante restent
     pilotés par theme.js. Ici on ne gère que l'articulation entre les deux
     niveaux de choix, dont la règle est explicite :

     - une pastille en haut de page est la valeur PAR DÉFAUT du lot. Elle
       réaligne toutes les lignes de toutes les cartes et met à jour le champ
       caché name="id" — c'est theme.js qui écrit ce champ, on ne fait que
       suivre l'événement variant:change qu'il émet. C'est aussi le repli sans
       JavaScript : le formulaire ne poste que ce champ.

     - un <select> de ligne est une EXCEPTION. Il ne modifie que sa ligne, ne
       touche ni les pastilles ni le champ caché. Le chemin inverse, où une
       liste rejouait la pastille correspondante, est supprimé : il faisait de
       chaque ligne une commande globale, ce qui est exactement ce qu'on veut
       éviter quand quatre oreillers peuvent être quatre coloris.

     Le réalignement touche aussi les cartes MASQUÉES. Le Liquid rend les lignes
     de toutes les cartes et le CSS ne montre que celles de la carte cochée :
     une ligne cachée qui garderait une valeur périmée ne se verrait jamais à
     l'écran, et partirait quand même au panier dès que la cliente change de
     carte. */

  function selectedCard() {
    var lot = $('input[name="quantity"]:checked');
    return lot ? lot.closest('[data-bcard]') : null;
  }

  /* La pastille du sélecteur suit la valeur choisie. La teinte est portée par
     l'<option> elle-même, posée par le Liquid depuis le bloc « Pastille de
     couleur » : aucune table de correspondance dupliquée ici. */
  function paintDot(sel) {
    var wrap = sel.closest('.bsel');
    if (!wrap) return;
    var opt = sel.options[sel.selectedIndex];
    var hex = opt && opt.getAttribute('data-swatch');
    if (hex) wrap.style.setProperty('--bsel-dot', hex);
    else wrap.style.removeProperty('--bsel-dot');
  }

  function hideNotes() {
    $$('[data-opt-note]').forEach(function (n) { n.textContent = ''; n.hidden = true; });
  }

  /* « personnalisé » à côté du nom de l'option, dès qu'une ligne de la carte
     cochée s'écarte de la pastille. Seule la carte cochée compte : c'est elle
     qui part au panier. Sans cette mention, « Couleur : Blanc » affirmerait que
     les quatre oreillers sont blancs alors qu'un seul l'est. */
  function syncCustom() {
    var card = selectedCard();
    $$('[data-opt-group]').forEach(function (g) {
      var flag = $('[data-opt-custom]', g);
      if (!flag) return;
      var idx = g.getAttribute('data-option-index');
      var on  = $('[aria-pressed="true"]', g);
      var off = true;
      if (card && on && idx !== null) {
        var val = on.getAttribute('data-value');
        off = !$$('[data-unit-select][data-option-index="' + idx + '"]', card)
          .some(function (s) { return s.value !== val; });
      }
      flag.hidden = off;
    });
  }

  /* Réalignement. L'écrasement des choix par ligne est volontaire — la pastille
     est la valeur par défaut du lot — mais il ne doit pas être silencieux : on
     l'annonce, et seulement quand il a réellement eu lieu. Le nombre et la
     valeur sont injectés dans le gabarit rendu par le Liquid, jamais
     concaténés ici. */
  function realign() {
    var card  = selectedCard();
    var count = card ? $$('[data-unit]', card).length : 0;

    $$('[data-opt-group]').forEach(function (g) {
      var note = $('[data-opt-note]', g);
      if (note) { note.textContent = ''; note.hidden = true; }

      var idx = g.getAttribute('data-option-index');
      var on  = $('[aria-pressed="true"]', g);
      if (idx === null || !on) return;
      var val = on.getAttribute('data-value');
      // [data-unit-select] seulement : [data-addon-select] est délibérément
      // hors du réalignement. La taie est un AUTRE produit, avec ses propres
      // options et sa propre table de coloris ; une pastille qui la repeindrait
      // en même temps que les oreillers ferait suivre à un produit le catalogue
      // d'un autre, et échouerait dès que les deux n'ont pas les mêmes valeurs.
      // Ce n'est pas un oubli : ne l'ajoutez pas ici.
      var sel = '[data-unit-select][data-option-index="' + idx + '"]';

      // Constaté sur la carte cochée avant de réécrire : c'est son écrasement
      // qu'on annonce, pas celui des cartes que la cliente ne voit pas.
      var overwritten = !!card && $$(sel, card).some(function (s) { return s.value !== val; });

      $$(sel).forEach(function (s) {
        if (s.value === val) return;
        s.value = val;
        paintDot(s);
      });

      if (!overwritten || !note || count < 1) return;
      var tpl = count === 1 ? note.getAttribute('data-one') : note.getAttribute('data-many');
      if (!tpl) return;
      note.textContent = tpl.replace('{count}', count).replace('{value}', val);
      note.hidden = false;
    });

    syncCustom();
    // Le réalignement écrit les valeurs sans qu'aucun 'change' ne parte de
    // lui-même. Cet événement prévient les deux dépendants — le contrôle de
    // disponibilité dans theme.js, la garde du paiement express plus bas — sans
    // que l'un ait à deviner l'ordre d'exécution de l'autre.
    document.dispatchEvent(new CustomEvent('units:change'));
  }

  function initBundleCards() {
    if (!$$('[data-unit-select], [data-addon-select]').length) return;

    $$('[data-unit-select], [data-addon-select]').forEach(paintDot);

    // Un seul écouteur délégué plutôt qu'un par élément : trois cartes de
    // quatre unités font vingt-quatre listes, et la carte cochée change.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-unit-select], [data-addon-select]')) {
        paintDot(t);
        // Toute action sur une ligne referme la mention d'écrasement : elle a
        // été lue, ou elle ne concerne plus ce que la cliente est en train de
        // faire.
        hideNotes();
      } else if (t && t.matches && t.matches('input[name="quantity"]')) {
        // Changer de lot change le nombre d'unités : « Les 3 unités sont
        // repassées en Blanc. » décrirait une carte que la cliente ne regarde
        // plus. La mention se referme avec la carte qu'elle décrivait, sinon
        // elle reste à l'écran en annonçant un compte faux.
        hideNotes();
      }
      syncCustom();
    });

    document.addEventListener('variant:change', realign);
    syncCustom();
  }

  /* ---------- Paiement express vs lot ----------------------------------- */
  /* Apple Pay et PayPal partent directement au paiement avec le seul contenu du
     formulaire : un identifiant de variante et une quantité. Ils sont donc faux
     dans deux cas, et on retire le bloc dans les deux plutôt que de laisser
     passer une commande incomplète.

     - la taie est cochée : elle est ajoutée par l'appel panier, l'express la
       perdrait sans le dire ;
     - deux lignes de la carte cochée portent des variantes différentes :
       l'express enverrait N fois la même, donc une commande fausse.

     La mention prend la place du bloc au lieu de disparaître avec lui. Sans
     JavaScript elle reste visible en permanence, ce qui est juste : l'express
     existe alors, et n'emporte effectivement pas la taie. */
  function initExpressGuard() {
    var pay = $('[data-pay]');
    if (!pay) return;
    var note  = $('[data-pay-note]');
    var addon = $('[data-addon]');

    /* Vraie sur la première ligne qui s'écarte de la première. La signature est
       rangée par indice d'option et non par ordre du DOM : deux lignes portant
       les mêmes valeurs dans un ordre différent sont la même variante. */
    function mixed() {
      var card = selectedCard();
      if (!card) return false;
      var rows = $$('[data-unit]', card);
      if (rows.length < 2) return false;
      var first = null;
      for (var i = 0; i < rows.length; i++) {
        var sig = $$('[data-unit-select]', rows[i]).map(function (s) {
          return s.getAttribute('data-option-index') + '=' + s.value;
        }).sort().join('|');
        if (first === null) first = sig;
        else if (sig !== first) return true;
      }
      return false;
    }

    /* L'offre est desormais rendue par une application, pas par le theme :
       mixed() ne trouve plus aucune ligne a comparer et rendrait toujours faux.
       L'application, elle, masque le bouton express d'elle-meme des que le lot
       reunit plus d'une variante — Apple Pay ne sait porter qu'une seule ligne,
       c'est une limite de Shopify et non un reglage. On ne la contredit pas :
       forcer le bouton a revenir enverrait N fois le meme coloris en caisse.
       On constate son geste, pour que la mention prenne la place laissee vide
       au lieu d'un trou que rien n'explique. */
    function appHid() {
      var w = pay.querySelector('[data-shopify="payment-button"], .shopify-payment-button');
      return !!w && w.style.display === 'none';
    }

    function sync() {
      var isMixed = mixed() || appHid();
      var isAddon = !!(addon && addon.checked);
      // Garde-fou optionnel, livre eteint. Allume, il masque l'express quand la
      // commande ne peut pas y passer telle quelle. Eteint, le bouton reste en
      // place quoi qu'il arrive et c'est la mention qui previent : un bouton
      // qui va et vient se lit comme une panne, une phrase se lit.
      var garde = pay.getAttribute('data-guard') === 'on';
      pay.classList.toggle('is-off', garde && (isMixed || isAddon));
      pay.hidden = false;
      if (!note) return;
      // Les variantes mêlées l'emportent : c'est la raison la plus lourde, et
      // celle que la cliente vient de provoquer.
      var txt = '';
      if (isMixed) txt = note.getAttribute('data-note-mixed') || '';
      else if (isAddon) txt = note.getAttribute('data-note-addon') || '';
      note.textContent = txt;
      note.hidden = txt === '';
    }

    document.addEventListener('change', sync);
    document.addEventListener('units:change', sync);
    /* L'application ecrit un style en ligne sans emettre le moindre evenement :
       sans observateur, la mention resterait en retard d'un clic. Le filtre est
       limite a 'style' expres — sync() touche la classe et l'attribut hidden du
       bloc, et un filtre plus large se rappellerait lui-meme sans fin. La
       mention, elle, vit hors de [data-pay] : l'ecrire n'observe rien. */
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(pay, {
        subtree: true, childList: true, attributes: true, attributeFilter: ['style']
      });
    }
    sync();
  }

  /* ---------- Bande de l'option sur une carte non cochée ----------------- */
  /* Le <label for> de la bande pointe la case unique de la page ; il ne peut
     donc pas, en plus, sélectionner sa carte. Le CSS le rend inerte tant que la
     carte n'est pas cochée, et trois bandes visibles dont deux mortes se lisent
     comme un bouton cassé.

     Un clic sur une bande inerte sélectionne désormais sa carte, ce que faisait
     l'ancien gestionnaire de carte entière avant que la rangée haute ne devienne
     un <label>. Il ne coche pas l'option au passage : choisir un lot et
     souscrire une option sont deux gestes, et les enchaîner sur un seul clic
     ferait payer une taie que personne n'a demandée. */
  function initBandSelect() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      // Le CSS neutralise le label, pas la bande : c'est elle qui reçoit le clic.
      var band = t.closest('.bcard__band');
      if (!band || t.closest('select')) return;
      var card = band.closest('[data-bcard]');
      var radio = card && card.querySelector('input[name="quantity"]');
      // Carte déjà cochée : c'est l'option taie que le clic doit basculer. On
      // ne s'en remet plus au seul <label for> : selon ce qui intercepte le
      // clic en amont, son activation peut ne jamais avoir lieu, et la bande
      // paraissait alors morte. Le clic sur un <select> est exclu plus haut.
      if (!radio) return;
      if (radio.checked) {
        // Un clic DANS un <label> est deja traite par le navigateur. Le
        // reprendre ici basculait la case une seconde fois : les deux bascules
        // s'annulaient et la bande paraissait morte. On ne gere donc que les
        // clics hors label — le prix, le vide autour.
        if (t.closest('input, label')) return;
        var box = document.querySelector('[data-addon]');
        if (box) {
          e.preventDefault();
          box.checked = !box.checked;
          box.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      e.preventDefault();
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      // La carte vient d'etre choisie par ce meme clic : on coche l'option dans
      // la foulee. Exiger un second clic donnait l'impression d'une case morte,
      // ce qui a ete rapporte deux fois.
      var box2 = document.querySelector('[data-addon]');
      if (box2 && !box2.checked) {
        box2.checked = true;
        box2.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function boot() {
    initCarousels();
    initRings();
    // initBundleCards avant initExpressGuard : le premier écrit les valeurs des
    // lignes, le second les lit. L'ordre d'enregistrement des écouteurs suit
    // celui des appels, et un garde qui lirait des valeurs d'avant le
    // réalignement masquerait ou montrerait le mauvais bloc.
    initBundleCards();
    initBandSelect();
    initExpressGuard();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
